<template>
  <div>
    <input
      :accept="accepted"
      @change="fileChange"
      class="file-input"
      ref="fileInput"
      type="file"
    />
    <template v-if="!uploadInProgress">
      <v-btn @click="uploadClick" icon v-if="fileData.name == ''">
        <v-icon small>fa-upload</v-icon>
      </v-btn>
      <v-btn @click="downloadClick" icon v-if="fileData.name != ''">
        <v-icon small>fa-download</v-icon>
      </v-btn>
      <v-btn @click="deleteClick" icon v-if="fileData.name != ''">
        <v-icon small>fa-trash</v-icon>
      </v-btn>
    </template>
    <div v-if="uploadInProgress">
      {{ $t('labels.uploadInProgress') }}
    </div>
  </div>
</template>

<style scoped>
.file-input {
  display: none;
}
</style>

<script>
import handle_session_error from '@/helpers/handle_session_error.js'

export default {
  name: 'Upload',
  props: ['value', 'accept'],
  components: {},
  data() {
    return {
      fileData: {
        name: '',
        link: '',
        original_name: '',
      },
      uploadInProgress: false,
      accepted: '',
    }
  },
  watch: {
    value: function () {
      this.fileData = this.$props.value
    },
  },
  methods: {
    uploadClick() {
      this.$refs.fileInput.click()
    },
    fileChange() {
      this.uploadInProgress = true
      var vm = this
      let file = this.$refs.fileInput.files[0]
      if (file.size <= 5 * 1024 * 1024) {
        this.$APIUpload(
          file,
          data => {
            if (data['success']) {
              vm.fileData = data['file']
              vm.uploadInProgress = false
              vm.$emit('input', vm.fileData)
            }
          },
          'UPLOAD',
          null,
          error => {
            handle_session_error(error, this.$store, this.$router, this.$prompt)
          }
        )
      } else {
        this.uploadInProgress = false
        this.$alert(this.$t('alerts.fileSize'))
      }
    },
    downloadClick() {
      window.open(this.fileData.link)
    },
    deleteClick() {
      var vm = this
      this.$verify(this.$t('alerts.fileDeletionQuestion'), result => {
        if (result) {
          vm.fileData = {
            name: '',
            link: '',
            original_name: '',
          }
          vm.$emit('input', vm.fileData)
        }
      })
    },
  },
  mounted() {
    if (this.accept !== undefined) {
      this.accepted = this.accept
    }
    this.fileData = this.$props.value
  },
}
</script>
